<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
          	<b-card header-bg-variant="info">
          		<h1 class="float-left display-3 mr-4">404</h1>
            	<h4 class="pt-3">Are you lost?</h4>
            	<p class="text-muted">Click the button below to get back on the trail path.</p>
            	<br>
            	<div slot="footer">
            		<b-row class="justify-content-center">
      					<b-button variant="primary" :to="'/dashboard'">Dashboard</b-button>
      				</b-row>        			
      			</div>            	
          	</b-card>            
          </div>
          <br>            
        </b-col>
      </b-row>      
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>
